import type { Dependencies } from "@redux/store";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { UpdateTimelineEventBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const updateTimelineEvent = createAsyncThunk<void, UpdateTimelineEventBody, { extra: Partial<Dependencies> }>(
  "timelineEvents/updateTimelineEvent",
  async (body: UpdateTimelineEventBody, { extra: { adminRepository } }) => {
    return adminRepository!.updateTimelineEvent(body);
  },
);

export const resetUpdateTimelineEvent = createAction("timelineEvents/resetUpdateTimelineEvent");
